"use client";

import createIcon from './util/createIcon';
export default createIcon('M12.07 19L9.24 16.18L19 6.42L17.58 5L7.82 14.76L5 11.94V19Z', 'ArrowBottomLeftThin');